import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import { connect } from 'react-redux'
import { fetchStoreSuggestion } from './actions'
import { Stores } from './reducer'

import '@loyal_template/stores.css'

class StoreSuggestion extends Component {
  componentDidMount () {
    this.props.fetchStoreSuggestion()
  }

  render () {
    if (this.props.onlyCash) {
      return ''
    }

    return (
      this.props.stores.length > 0 && (
        <div className='bx-showcase container-fluid bg-ui-5 mx-0 mx-md-auto px-0 py-3'>
          <div className='container-stores container mx-2 mx-auto px-0 px-md-1'>
            <div className='row mx-0'>
              <div className='col-auto mr-auto mb-2 mb-md-4 mx-0 px-0'>
                <h2 className='txt-font-title color-title d-none d-md-block px-md-0 px-2 pt-0 pt-md-1 pt-xl-0'>
                  Encontre as suas lojas favoritas.
                </h2>
                <h2 className='txt-font-title color-title d-block d-md-none px-md-0 px-2'>
                  Marcas
                </h2>
              </div>
            </div>
            <div className='row mx-0'>
              {renderCardStores('col-6 col-md-3 my-half mx-half')}
            </div>
          </div>
        </div>
      )
    )
  }
}

const renderCardStores = (className = '') => {
  const sotoresCustom = [{
    id: 59,
    imageUrl: 'https://blbltmlive001.blob.core.windows.net/supplier/Livec218d5a7-d5d5-482d-8ea0-b07fdfab34e5.jpg',
    name: 'Extra.Com'
  },
  {
    id: 58,
    imageUrl: 'https://blbltmlive001.blob.core.windows.net/supplier/Livee3f443f3-c71e-4a0a-982b-fbc1fc87b678.jpg',
    name: 'Ponto Frio'
  },
  {
    id: 106,
    imageUrl: 'https://blbltmlive001.blob.core.windows.net/supplier/img_lg_fastshop.jpg',
    name: 'FastShop'
  },
  {
    id: 62,
    imageUrl: 'http://blbltmlive001.blob.core.windows.net/supplier/Live7ab94d1a-554f-496a-82c5-93ffb61f1872.jpg',
    name: 'Magazine Luiza'
  }
  ]

  return sotoresCustom.slice(0, 4).map((ItemStore, index) => (
    <div key={index} className={`item card px-0 vendor_${ItemStore.id} ${className || ''}`}>
      <div className='row mx-0 h-100'>
        <div className='col-md-12 h-100'>
          <Link to={`/vendor?vendor=${ItemStore.id}`} title={ItemStore.name} >
            <div className='card-store row px-half py-half  h-100'>
              <div className='col-12 h-100 px-2 py-3 border-color-ui-3 border bg-white radius'>
                <div className='row align-items-center h-100'>
                  <div className='col-12  txt-center'>
                    <img src={ItemStore.imageUrl} alt={ItemStore.name} className='mw-100' />
                  </div>
                </div>
              </div>
            </div>
          </Link>
        </div>
      </div>
    </div>
  ))
}

StoreSuggestion.propTypes = {
  fetchStoreSuggestion: PropTypes.func,
  stores: PropTypes.array,
  onlyCash: PropTypes.bool
}

const mapStateToProps = ({ storeSuggestion, onlyCash }) => ({
  ...Stores(storeSuggestion),
  onlyCash
})

const mapDispatchToProps = dispatch => ({
  fetchStoreSuggestion: () => dispatch(fetchStoreSuggestion('home'))
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(StoreSuggestion)



// WEBPACK FOOTER //
// ./src/features/Suggestion/StoreSuggestion/StoreSuggestion.js